module.exports = __webpack_public_path__ + "static/media/ftrgrnlg.e62ceecb.png";